@if (addLayerService.projectHasDepositFolder()) {
    <span class="custom-text">{{ 'data' | transloco: { count: 1 } }}</span>
    <div class="w-5/6 pb-6">
        <app-select-by-group
            labelNoGroup="nonStandard"
            placeholder="selectData"
            [defaultValue]="depositFolderDefaultValue()"
            [optionsByGroup]="optionsByGroup()"
            (optionSelected)="selectDepositFolder($event)" />
    </div>
} @else if (addLayerService.isDepositFolderLoading()) {
    <app-loading />
} @else {
    <div class="pb-6">
        <span class="custom-text">{{ 'noDataInOrganization' | transloco }}</span>
    </div>
}

@if (addLayerService.selectedDepositFolder()) {
    @if (addLayerService.depositFolderHasDeposits()) {
        <span class="custom-text">{{ 'table' | transloco: { count: 1 } }}</span>
        <div class="w-5/6 pb-6">
            <app-select
                placeholder="selectADeposit"
                [defaultValue]="depositDefaultValue()"
                [options]="addLayerService.depositOptions()"
                (optionSelected)="selectDeposit($event)" />
        </div>
    } @else if (isDepositLoading()) {
        <app-loading />
    } @else {
        <div class="pb-6">
            <span class="custom-text">{{ 'noDepositInData' | transloco: { count: 1 } }}</span>
        </div>
    }
}

@if (addLayerService.selectedDeposit()) {
    <!-- The 'max-w-96' prevents accidentally checking the checkbox before moving to another step of the add layer modal -->
    <div
        class="flex flex-row cursor-pointer max-w-96"
        (click)="toggleLockVersion()">
        <app-checkbox
            [checkboxState]="addLayerService.isLockVersion() ? CheckboxState.CHECKED : CheckboxState.UNCHECKED" />
        <span class="pl-2 custom-text">{{ 'lockDepositVersion' | transloco }}</span>
    </div>
}
